import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import DevicesTab from './components/DevicesTab';
import EncountersTab from './components/EncountersTab';
import VulnerabilitiesTab from './components/VulnerabilitiesTab';

import './MapLegend.scss';

const containerStyle: React.CSSProperties = {
  position: 'absolute',
  left: 10,
  bottom: 10,
  zIndex: 1200,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
};

const transition = 'all 0.25s cubic-bezier(0.4,0,0.2,1)';

const buttonBaseStyle: React.CSSProperties = {
  width: 34,
  height: 34,
  borderRadius: 4,
  border: '2px solid #6f42c1',
  background: '#fff',
  fontSize: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
  transition,
  overflow: 'hidden',
  padding: 0,
};

const legendExpandedStyle: React.CSSProperties = {
  width: 320,
  minHeight: 220,
  borderRadius: 8,
  fontSize: 14,
  padding: '18px 24px 18px 24px',
  fontFamily: 'Poppins, Arial, sans-serif',
  boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
  background: '#fff',
  border: '3px solid #ccc',
  transition,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
};

const MapLegend: React.FC = () => {
  const [hovered, setHovered] = useState(false);
  const [tabName, setTabName] = useState<'devices' | 'encounters' | 'vulnerabilities'>('devices');
  const { t } = useTranslation();

  return (
    <div
      style={containerStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="cursor-pointer"
    >
      <div
        style={{
          ...buttonBaseStyle,
          ...(hovered ? legendExpandedStyle : {}),
          width: hovered ? 340 : 34,
          height: hovered ? 650 : 34,
          padding: hovered ? '18px 24px 18px 24px' : 0,
        }}
      >
        {!hovered && (
          // Button icon (gray circle with horizontal line)
          // <i className="ri-share-forward-box-line fs-20" style={{ color: '#6c3fc5' }} />
          <h5
            className="fs-20 mt-2 fw-semibold d-flex align-items-center justify-content-center"
            style={{ color: '#6c3fc5' }}
          >
            i
          </h5>
        )}
        {hovered && (
          <div style={{ width: '100%' }}>
            <div className="d-flex gap-2 justify-content-center border-bottom pb-2 mb-2">
              <button
                className={`btn btn${tabName !== 'devices' ? '-ghost' : ''}-purple`}
                onClick={() => setTabName('devices')}
              >
                {t('MapLegend.devices')}
              </button>
              <button
                className={`btn btn${tabName !== 'encounters' ? '-ghost' : ''}-purple`}
                onClick={() => setTabName('encounters')}
              >
                {t('MapLegend.sightings')}
              </button>
              <button
                className={`btn btn${tabName !== 'vulnerabilities' ? '-ghost' : ''}-purple`}
                onClick={() => setTabName('vulnerabilities')}
              >
                {t('MapLegend.pccs')}
              </button>
            </div>
            {tabName === 'devices' && <DevicesTab />}
            {tabName === 'encounters' && <EncountersTab />}
            {tabName === 'vulnerabilities' && <VulnerabilitiesTab />}
          </div>
        )}
      </div>
    </div>
  );
};

export default MapLegend;
